import * as signalR from "@microsoft/signalr";

const HUB_URL = "https://mdm.familytogetherkap.uk/hub/device";

export const hubConnection = new signalR.HubConnectionBuilder()
  .withUrl(HUB_URL)
  .withAutomaticReconnect()
  .configureLogging(signalR.LogLevel.Information)
  .build();

export function startSignalR() {
  if (hubConnection.state === signalR.HubConnectionState.Disconnected) {
    hubConnection
      .start()
      .catch(err => console.error("SignalR Connection Error:", err));
  }
}
